import { SelectDataType } from "@sso/components/Form";
import { UserForm } from "@sso/types";

export enum UserKeys {
  ID = "userId",
  FIRST_NAME = "firstname",
  LAST_NAME = "lastname",
  USER_NAME = "username",
  FULL_NAME = "fullName",
  EMAIL = "email",
  MOBILE = "mobile",
  ROLE = "role",
  ROLES = "roles",
  ROLE_ID = "roleId",
  ROLE_NAME = "roleName",
  ORGANISATION = "organisation",
  ORGANISATION_ID = "organisationId",
  ORGANISATION_NAME = "organisationName",
  CREATED = "createDate",
  LAST_LOGIN = "lastLoginDate",
  PICTURE = "picture",
  SOFTWARES = "softwares",
  SOFTWARES_NAME = "softwares.Name",
}

export enum UserRole {
  PUBLIC = "1214885f-8527-48ac-878e-a923761a9027",
  ORG_ADMIN = "1313885f-8527-48ac-878e-a923761a9027",
  ADMINISTRATOR = "1115885f-8527-48ac-878e-a923761a9027",
}

export const roleOption: SelectDataType[] = [
  { key: UserRole.PUBLIC, value: "Public", label: "Public" },
  { key: UserRole.ORG_ADMIN, value: "OrganisationAdmin", label: "Organisation Admin" },
  { key: UserRole.ADMINISTRATOR, value: "Administrator", label: "Administrator" },
];

export const userInitialValues: UserForm = {
  [UserKeys.ID]: "",
  [UserKeys.FIRST_NAME]: "",
  [UserKeys.LAST_NAME]: "",
  [UserKeys.USER_NAME]: "",
  [UserKeys.EMAIL]: "",
  [UserKeys.MOBILE]: "",
  //set the key of roleOption as a initial value because we want to get the key in onChange func.
  //set -1 to show "Select..." value (it would be a default value)
  [UserKeys.ROLE_ID]: UserRole.PUBLIC,
};
